import "./MenuSettings.css";

import { useState } from "react";
import { regUses } from "../../axios_with_token";
import ObjEdit from "../../widgets/ObjEdit/ObjEdit";

export default function MenuSettings({}){
    const {regUse, DefaultResponse} = regUses();
    return <DefaultResponse>
        <div className="container">
            <h1>menu settings</h1>
            <ObjEdit></ObjEdit>
        </div>
    </DefaultResponse>;
}